module.exports = __webpack_public_path__ + "static/nick-1075365436217a1ce82cec66577264e4.jpg";